import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.116 5.407a2.5 2.5 0 1 0-1.916.575l.788 2.624a5.5 5.5 0 1 0 7.406 7.406l2.624.787a2.5 2.5 0 1 0 .575-1.915l-2.625-.788a5.474 5.474 0 0 0-.936-3.714l4.554-4.554a2.5 2.5 0 1 0-1.414-1.414L9.618 8.968a5.475 5.475 0 0 0-3.714-.936l-.788-2.625zM10 13.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"
});

var SvgAffiliateMajor = function SvgAffiliateMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgAffiliateMajor as S };
